import type { RecordManualCheckRequest, WithdrawManualCheckRequest } from '@stm/contracts';

export function manualCheckPath(
  base: string,
  matchId: string,
  key: string,
  withdraw: boolean,
): string {
  const path = `${base}/matches/${encodeURIComponent(matchId)}/manual-checks/${encodeURIComponent(key)}`;
  return withdraw ? `${path}/withdraw` : path;
}

/** The request for the form, or null while no statement is typed or the day is not a full date. */
export function recordManualCheckRequest(
  statement: string,
  checkedOn: string,
): RecordManualCheckRequest | null {
  const trimmed = statement.trim();
  if (trimmed === '' || !/^\d{4}-\d{2}-\d{2}$/.test(checkedOn)) return null;
  return { statement: trimmed, checkedOn };
}

/** The withdrawal request, or null while no reason is typed. */
export function withdrawManualCheckRequest(reason: string): WithdrawManualCheckRequest | null {
  const trimmed = reason.trim();
  return trimmed === '' ? null : { reason: trimmed };
}
